/**
 * Created by kldavis on 2/23/17.
 */
var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.DynamicScriptLoaderJob = new Class({
    Implements: [new Class(OCS.Interfaces.UniqueId), Chain, Events, Options, Class.Thenable],
    job_id: null,
    next_run_timeout_id: null,
    is_finished: false,
    ajax_manager: null,
    options: {
        'classname': "OCS.Classes.DynamicScriptLoaderJob", // The class that is executing this call
        'loaded': [], // An array of already loaded scripts
        'load': [], // An array of scripts that are to be loaded.
        'remove': [], // An array of scripts that are to be removed from the DOM.
        'prepend': false, // Wether or not we prepend the script in the header or append it to the list
        'job_phase': 1, // The active job phase this job is in
        'completed_job_phase': 1, // The job phase number at which this job is deemed completed
        'remove_flag': false, // Flag to be set when this job is to work in reverse and remove item
        'debug': false // Display the debug related prompts
    },
    initialize: function (op) {
        this.setOptions(op);
        if (this.options.debug) {
            console.debug(this.options.classname + ": Created with options, ", op);
        }
        this.register_events();
        this.register_complete_event();
    },
    register_events: function () {
        this.addEvent('job_phase_complete', this.on_job_phase_complete.bind(this));
    },
    register_complete_event: function () {
        this.addEvent('initial_load_complete', this.complete.bind(this));
    },
    remove_events: function () {
        this.removeEvents();
    },
    run: function () {
        this.initial_remove();
        this.initial_load();

        return this;
    },
    cancel: function () {
        this.reject({reason: 'cancel'});
    },
    initial_load: function () {
        this.job_load(this.options.load);
    },
    initial_remove: function () {
        this.remove_scipts(this.options.remove);
        if (this.options.debug) {
            console.log('OCS.DynamicScriptLoaderJob: Job ' + this.get_job_id() + ' initial remove is completed.');
        }
        this.initial_remove_complete();
    },
    job_load: function (urls, complete_callback) {
        var run, run_ops;
        if (this.is_finished) {
            return;
        }
        if (this.options.remove_flag) {
            this.remove_scipts(urls);
            return this.job_phase_complete();
        }
        if (urls && Array.isArray(urls) && urls.length) {
            run = this.get_loader_run({load: urls, debug: this.options.debug, prepend: this.options.prepend, job_id: this.get_job_id()});
            run.addEvent('script_loaded', this.script_loaded.bind(this));
            run.addEvent('complete_run', function (res) {
                this.job_phase_complete(res);
            }.bind(this));
            if (complete_callback) {
                run.addEvent('complete_run', complete_callback);
            }
            run.start();
        } else {
            this.job_phase_complete();
            if (complete_callback) {
                complete_callback();
            }
        }
    },
    // Get / Set methods
    get_loader_run: function (run_ops) {
        return new OCS.Classes.DynamicScriptLoaderRun(run_ops);
    },
    get_job_id: function () {
        if (!this.job_id) {
            this.job_id = this.create_unique_id();
        }
        return this.job_id;
    },
    remove_scipts: function (urls) {
        if (this.is_finished) {
            return;
        }
        if (urls && Array.isArray(urls) && urls.length) {
            urls.forEach(function (url) {
                if (OCS.DynamicScriptLoader.job_manager.is_script_finished_loaded(url)) {
                    OCS.DynamicScriptLoader.job_manager.remove_script(url);
                }

            }.bind(this));
        }
    },
    job_phase_complete: function () {
        this.fireEvent('job_phase_complete', {phase: this.options.job_phase});
    },
    on_job_phase_complete: function (event) {
        this.options.job_phase++;
        if (event.phase === 1) {
            this.initial_load_complete();
        }
    },
    is_job_finished: function () {
        return this.is_finished;
    },
    // Events
    initial_remove_complete: function () {
        this.fireEvent('initial_remove_complete', this, 1);
    },
    script_loaded: function (event) {
        this.fireEvent('script_loaded', event);
    },
    initial_load_complete: function () {
        this.fireEvent('initial_load_complete');
    },
    complete: function () {
        this.is_finished = true;
        if (this.options.debug) {
            console.log('OCS.' + this.options.classname + ': ' + this.get_job_id() + ' is completed!');
        }

        this.fireEvent('complete', this);
        this.resolve({result: 'success', job: this});
        this.remove_events.delay(10, this);
    }
});